module.exports = __webpack_public_path__ + "res/ic_camera_rotate.e913b0c3cea3c002f0a13f72c2996480.png";